import { render, staticRenderFns } from "./template.html?vue&type=template&id=058a8f6b&scoped=true&"
import script from "./NewForm.vue?vue&type=script&lang=js&"
export * from "./NewForm.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=058a8f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a8f6b",
  null
  
)

export default component.exports